exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".history{margin-bottom:44px}.history .header-title{border-bottom:1px solid #d2d2d2;max-width:720px;margin:35px auto}.history .loading-history .history-list{padding:0}", "", {"version":3,"sources":["/Users/danialkraven/Vue/saifi-chronoswiss-01/src/components/History.vue"],"names":[],"mappings":"AACA,SACE,kBAAoB,CACrB,AACD,uBACI,gCAAiC,AACjC,gBAAiB,AACjB,gBAAkB,CACrB,AACD,wCACI,SAAW,CACd","file":"History.vue","sourcesContent":["\n.history {\n  margin-bottom: 44px;\n}\n.history .header-title {\n    border-bottom: 1px solid #d2d2d2;\n    max-width: 720px;\n    margin: 35px auto;\n}\n.history .loading-history .history-list {\n    padding: 0;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-38cf2b5c","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"sourceMap":true}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/History.vue
// module id = 1027
// module chunks = 14